import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Share1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M6.433 5.9a.6.6 0 0 1 .097 1.192l-.097.008-.584-.001a.69.69 0 0 0-.645.643l-.002 6.406a.7.7 0 0 0 .171.501.7.7 0 0 0 .35.216l.09.015 5.964.001a.69.69 0 0 0 .645-.643l.002-6.406a.7.7 0 0 0-.171-.501.7.7 0 0 0-.35-.216l-.09-.015h-.51a.6.6 0 0 1-.097-1.192l.097-.008.546.001c.502.03.97.259 1.303.636.296.334.462.762.474 1.178l-.003.155-.001 6.202a1.9 1.9 0 0 1-.47 1.371 1.9 1.9 0 0 1-1.163.62l-.176.017-6.036-.001a1.9 1.9 0 0 1-1.303-.636A1.88 1.88 0 0 1 4 14.265l.003-.155.001-6.202a1.9 1.9 0 0 1 .47-1.371 1.9 1.9 0 0 1 1.162-.62l.177-.017zm2.746-3.81.079.058 1.6 1.4a.6.6 0 0 1-.703.967l-.087-.063-.606-.53V9.89a.6.6 0 0 1-1.191.097l-.008-.097-.001-5.968-.604.53a.6.6 0 0 1-.768.018l-.079-.075a.6.6 0 0 1-.018-.768l.075-.079 1.6-1.4a.6.6 0 0 1 .71-.058z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Share1$1 = Svg18Share1;

export { Svg18Share1$1 as default };
